import React from "react";
import { List, Avatar,  Modal } from "antd";
import { AppstoreFilled } from "@ant-design/icons";
// import { useContext } from "react";
// import SystemContext from "./contextAPI/SystemContext";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { Button } from "reactstrap";
// import _ from "lodash";
// import { remove } from "lodash";

import { ExclamationCircleOutlined } from "@ant-design/icons";
import { add_system, reset_system } from "../../Redux/actions";
import { warning } from "../../Controllers/toast";

const { confirm } = Modal;

const ListSystem = (props) => {
  const new_system = useSelector((state) => state.add_system);
  const dispatch = useDispatch();
  // const [data, setData] = useState(new_system);
  // var [count, setCount] = useState(new_system.length);


  // useEffect(() => {
  //   // console.log(new_system, "is new_system");
  // });

  // console.log(data, " is data for deleting");

  

  return (
    <List
    size={(props.size)?props.size:"default"}
      pagination={{
        onChange: (page) => {
          // console.log(page);
        },
        pageSize: 10,
      }}
      itemLayout="horizontal"
      dataSource={new_system}
      renderItem={(item) => {
        
      
        var key = new_system.indexOf(item) + 1;
        // console.log(key , "is key")
        return (
          <List.Item
            key={key}
            actions={(props.disableAction !== true)?[
              <Button
                key="list-loadmore-edit"
                color="link"
                onClick={() => {
                  const showDeleteConfirm = () => {
                    confirm({
                      title: "آیا از حذف دستگاه خود مطمئن هستید؟",
                      icon: <ExclamationCircleOutlined />,
                      content:
                        "در صورتی که دستگاهی را حذف کنید می توانید دوباره آن را اضافه کنید.",
                      okText: "حذف",
                      okType: "danger",
                      cancelText: "بازگشت",
                      onOk() {
                        // console.log("OK" , e , item);
                      
                        // console.log(data, "is item data");
                        dispatch(reset_system(item.serial_number));
                        warning(`دستگاه ${item.serial_number} با موفقیت حذف شد!`)
                        // console.log(new_system, "new data of new_system!");
                        // dispatch(add_system(data.filter((value) => value !== item)));

                        // dispatch(add_system());
                        // console.log(new_system , "new new_system")
                      },
                      onCancel() {
                        // console.log("Cancel");
                      },
                    });
                  };

                  showDeleteConfirm();

                  // delete new_system[new_system.indexOf(item)];
                  // console.log("onClick!", key, "and newArr is :", e);
                }}
              >
                حذف
              </Button>,
              <Button key="list-loadmore-more" color="link">
                بیشتر
              </Button>,
            ]:""}
          >
            <List.Item.Meta
              avatar={<Avatar className="mr-3" icon={<AppstoreFilled />} />}
              title={
                <a href="https://ant.design">
                  {item.serial_number} 
                </a>
              }
              description={item.serial_number}
            />
          </List.Item>
        );
      }}
    />
    
  );
};
export default ListSystem;
